import { extendObservable, runInAction } from 'mobx';

import { Logger } from '../helpers/Logger';
import { Storage } from '../helpers/Storage';
import { Location } from '../models/Location';
import { LocationController } from '../networking/controllers/LocationController';

const DEPARTMENTS_STORAGE_KEY = 'locationstore-departments';
const MAX_RETRIES = 3;

class LocationStoreClass {
  constructor() {
    extendObservable(this, {
      departments: null,
      locations: null,
      departmentByPoint: null,
      locationByPoint: null,
    });
    this.retries = 0;
    this.fetchDepartmentsFromStorage();
  }

  fetchDepartmentsFromStorage() {
    const departments = Storage.get(DEPARTMENTS_STORAGE_KEY);
    if (departments) {
      Logger.log('Departments found on storage');
      runInAction(() => {
        this.departments = departments.filter(x => x !== undefined);
      });
    }
    this.fetchDepartments();
  }

  async searchAddressesByPoint(lat, lng) {
    try {
      const zone = await LocationController.getZoneByPoint(lat, lng);
      if (zone) {
        await this.getLocations(zone.department);
        runInAction(() => {
          this.departmentByPoint = zone.department;
          this.locationByPoint = zone.locality;
        });
      } else {
        runInAction(() => {
          this.departmentByPoint = null;
          this.locationByPoint = null;
        });
      }
      Logger.log('Departments loaded correctly');
    } catch (error) {
      Logger.warn(`Failed to fetch departments, retried ${this.retries} times, error was: ${error.message}`);
    }
  }

  async fetchDepartments() {
    if (this.retries > MAX_RETRIES) {
      Logger.warn('Department fetching exceeded retry limit.');
      return;
    }
    try {
      const departments = await LocationController.getDepartments();
      departments.filter(x => x !== undefined).sort((a, b) => a.index - b.index);
      Storage.set(DEPARTMENTS_STORAGE_KEY, departments);
      this.retries = 0;
      runInAction(() => {
        this.departments = departments;
        this.locations = null;
      });
      Logger.log('Departments loaded correctly');
    } catch (error) {
      Logger.warn(`Failed to fetch departments, retried ${this.retries} times, error was: ${error.message}`);
      // Retry
      this.retries += 1;
      this.fetchDepartments();
    }
  }

  async getLocations(departmentID) {
    runInAction(() => {
      this.locations = null;
    });
    try {
      let locations = await LocationController.getLocations(departmentID);
      locations = locations.filter(x => !x.name.includes('#'));
      runInAction(() => {
        this.locations = locations;
      });
    } catch (error) {
      Logger.warn(error);
    }
  }

  addLocation(id, name) {
    const newLocation = new Location({
      id,
      name,
    });
    if (this.locations) {
      runInAction(() => {
        this.locations.push(newLocation);
      });
    }
  }

  clearLocations() {
    runInAction(() => {
      this.locations = null;
    });
  }
}

const LocationStore = new LocationStoreClass();

export { LocationStore };



// WEBPACK FOOTER //
// ./src/stores/LocationStore.js